export const isMac = () => {
  const { userAgentData } = navigator as Navigator & {
    userAgentData?: { platform?: string };
  };
  const platform = userAgentData?.platform || navigator.platform;

  return platform.toUpperCase().indexOf('MAC') >= 0;
};
